// extracted by mini-css-extract-plugin
export default {"container":"Logout_container__0Ylqn","centerAlignedColumn":"Logout_centerAlignedColumn__510wz","loginText":"Logout_loginText__thc3-"};